module.exports = __webpack_public_path__ + "img/punto-verde.83ba0c6b.png";